import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type Observable } from 'rxjs';
import { type TowingAttachment } from './towing-attachment.model';

@Injectable({ providedIn: 'root' })
export class TowingAttachmentsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `api/v1/tickets/towing/workups/current`;

  loadDamagesPhotos(): Observable<Array<TowingAttachment>> {
    return this.http.get<Array<TowingAttachment>>(`${this.baseUrl}/damages/photos`);
  }

  loadInventoryPhotos(): Observable<Array<TowingAttachment>> {
    return this.http.get<Array<TowingAttachment>>(`${this.baseUrl}/inventory/photos`);
  }

  downloadDamagePhoto(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/damages/photos/${id}/file`, { responseType: 'blob' });
  }

  downloadInventoryPhoto(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/inventory/photos/${id}/file`, { responseType: 'blob' });
  }
}
